import { RecurrenceTab } from './components/event-dialog/RecurrenceTab';
import { RecurringScopeDialog } from './components/recurring-scope-dialog/RecurringScopeDialog';

export const PREMIUM_EVENT_DIALOG_OPTIONAL_RENDERERS = {
  recurrenceTab: RecurrenceTab,
  recurringScopeDialog: RecurringScopeDialog,
};
